<div
  class="visionboard-item-controls-container"
  [class.mobile]="mobileMode"
>
  <app-visionboard-item-favorite-button-menu
    [item]="item"
    [favoritesList]="favoritesList"
    [source]="source"
  ></app-visionboard-item-favorite-button-menu>
  <ng-container *ngIf="!mobileMode && (isHovered || (isMenuOpen$ | async))">
    <ng-container
      *ngTemplateOutlet="
        customAddRemoveTemplate ?? defaultAddRemoveTemplate;
        context: {
          $implicit: item,
          source: source,
          forceVisionboardItemAddRemoveButton: forceVisionboardItemAddRemoveButton,
          isMenuOpen$: isMenuOpen$
        }
      "
    ></ng-container>
    <ng-container
      *ngTemplateOutlet="
        customMoreActionsTemplate ?? defaultMoreActionsTemplate;
        context: { $implicit: item, source: source, showMoreActionsMenu: showMoreActionsMenu, isMenuOpen$: isMenuOpen$ }
      "
    ></ng-container>
  </ng-container>
</div>

<ng-template
  #defaultMoreActionsTemplate
  let-item
  let-source="source"
  let-showMoreActionsMenu="showMoreActionsMenu"
  let-isMenuOpen$="isMenuOpen$"
>
  <app-visionboard-item-more-actions-menu
    [item]="item"
    [source]="source"
    [isMenuOpen$]="isMenuOpen$"
    *ngIf="showMoreActionsMenu"
  ></app-visionboard-item-more-actions-menu>
</ng-template>

<ng-template
  #defaultAddRemoveTemplate
  let-item
  let-source="source"
  let-forceVisionboardItemAddRemoveButton="forceVisionboardItemAddRemoveButton"
>
  <app-visionboard-item-add-remove-button
    [item]="item"
    [forceVisionboardItemAddRemoveButton]="forceVisionboardItemAddRemoveButton"
    [source]="source"
  ></app-visionboard-item-add-remove-button>
</ng-template>
